import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { Store } from '@ngxs/store';
import { MainFormService } from '@records/controls/record-container/main-form.service';
import { CURRENT_DATA_STATE_TOKEN } from '@records/state/current-data/current-data-state.token';
import { CbreLogger, CbreLoggerToken } from '@cbre/logger';

interface ValidationErrorData {
  controlName: string;
  errorName: string;
  errorValue: any;
  controlPath: string;
}
@Component({
  selector: 'miq-console',
  templateUrl: './console.component.html',
  styleUrls: ['./console.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ConsoleComponent {
  isDebugEnabled = false;
  constructor(
    private store: Store,
    private mainFormService: MainFormService,
    @Inject(CbreLoggerToken) private logger: CbreLogger
  ) {}

  debug() {
    if (!this.mainFormService.mainForm) return;
    const err = this.getFormValidationErrors(this.mainFormService.mainForm.controls);
    const state = this.store.selectSnapshot(CURRENT_DATA_STATE_TOKEN);

    this.logger.debug(`Showing errors main form -> ${err}`);
    this.logger.debug(`Showing current record data -> ${state}`);
    debugger;
  }

  toggleDebugConsole() {
    this.isDebugEnabled = !this.isDebugEnabled;
  }

  private getFormValidationErrors(controls: any, path = 'control'): Array<ValidationErrorData> {
    function toArraySyntax(innerPath: string): string {
      return innerPath.split('.').reduce((acc, cur) => (Number.parseInt(cur) ? `${acc}[${cur}]` : `${acc}.${cur}`), '');
    }

    let errors: ValidationErrorData[] = [];

    Object.keys(controls).forEach(key => {
      const control = controls[key];
      path += '.' + key;
      if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
        errors = errors.concat(this.getFormValidationErrors(control.controls, path));
      }

      const controlErrors: ValidationErrors = controls[key].errors;
      if (controlErrors !== null) {
        Object.keys(controlErrors).forEach(keyError => {
          errors.push({
            controlName: key,
            errorName: keyError,
            errorValue: controlErrors[keyError],
            controlPath: toArraySyntax(path),
          });
        });
      }
      path = path.split('.').slice(0, -1).join('.');
    });
    return errors;
  }
}
